import React from "react";
import styles from "./Main.module.css";
import { useState } from "react";

export default function Main() {
  const [isOpen, setIsOpen] = useState(false);
  const textToCopy = "A3jryHBxorZ75vLwSr7mMNLfLvmTGxc6UcjyLbMUpump";
  const handleCopyToClipboard = () => {
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        console.log("error");
      })
      .catch((err) => {
        console.error("error: ", err);
      });
  };
  return (
    <div className={styles.cont}>
      <div className={styles.header_cont}>
        <div className={styles.left_cont_header}>
          <a
            className={styles.ref_ico}
            href="https://t.me/PepenutSolana"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              backgroundImage: "url(images/main/tg_ico.svg)",
            }}
          ></a>
          <a
            className={styles.ref_ico}
            href="https://dexscreener.com/solana/A3jryHBxorZ75vLwSr7mMNLfLvmTGxc6UcjyLbMUpump"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              backgroundImage: "url(images/main/eg_ico.svg)",
            }}
          ></a>
          <a
            className={styles.ref_ico}
            href="https://x.com/pepenutsolana"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              backgroundImage: "url(images/main/x_ico.svg)",
            }}
          ></a>
          <a
            className={styles.ref_ico}
            href="https://solscan.io/token/A3jryHBxorZ75vLwSr7mMNLfLvmTGxc6UcjyLbMUpump"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              backgroundImage: "url(images/main/smth_ico.svg)",
            }}
          ></a>
        </div>
        <div className={styles.right_cont_header}>
          <a
            className={styles.buy_btn}
            href="https://raydium.io/swap/?inputMint=sol&outputMint=A3jryHBxorZ75vLwSr7mMNLfLvmTGxc6UcjyLbMUpump"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              backgroundImage: "url(images/main/bue_ico.png)",
            }}
          ></a>
          <a
            className={styles.ref_ico}
            href="https://instagram.com/yourusername"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              backgroundImage: "url(images/main/inst_ico.svg)",
            }}
          ></a>
          <a
            className={styles.ref_ico}
            href="https://tiktok.com/@yourusername"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              backgroundImage: "url(images/main/tt_ico.svg)",
            }}
          ></a>
        </div>
      </div>
      <div className={styles.header_cont_mob}>
        <a
          className={styles.buy_btn_mob}
          href="https://raydium.io/swap/?inputMint=sol&outputMint=A3jryHBxorZ75vLwSr7mMNLfLvmTGxc6UcjyLbMUpump"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            backgroundImage: "url(images/main/bue_ico.png)",
          }}
        ></a>
        <div
          className={styles.btn_menu}
          onClick={() => setIsOpen(!isOpen)}
          style={{
            backgroundImage: "url(images/new/close.png)",
          }}
        ></div>
      </div>
      <div
        className={styles.title}
        style={{
          backgroundImage: "url(images/main/title.png)",
        }}
      ></div>
      <div className={`${styles.menu} ${isOpen ? styles.active : ""}`}>
        <div
          className={styles.close_btn}
          onClick={() => setIsOpen(!isOpen)}
          style={{
            backgroundImage: "url(images/main/close.svg)",
          }}
        ></div>
        <div className={styles.menu_ico_cont}>
          <a
            className={styles.menu_ico}
            href="https://t.me/PepenutSolana"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              backgroundImage: "url(images/main/tg_ico.svg)",
            }}
          ></a>
          <a
            className={styles.menu_ico}
            href="https://dexscreener.com/solana/A3jryHBxorZ75vLwSr7mMNLfLvmTGxc6UcjyLbMUpump"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              backgroundImage: "url(images/main/eg_ico.svg)",
            }}
          ></a>
          <a
            className={styles.menu_ico}
            href="https://x.com/pepenutsolana"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              backgroundImage: "url(images/main/x_ico.svg)",
            }}
          ></a>
          <a
            className={styles.menu_ico}
            href="https://solscan.io/token/A3jryHBxorZ75vLwSr7mMNLfLvmTGxc6UcjyLbMUpump"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              backgroundImage: "url(images/main/smth_ico.svg)",
            }}
          ></a>
          <a
            className={styles.menu_ico}
            href="https://instagram.com/yourusername"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              backgroundImage: "url(images/main/inst_ico.svg)",
            }}
          ></a>
          <a
            className={styles.menu_ico}
            href="https://tiktok.com/@yourusername"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              backgroundImage: "url(images/main/tt_ico.svg)",
            }}
          ></a>
        </div>
      </div>

      <img className={styles.chara_img} src="./images/new/chara_1.png" alt="character" />
      <img className={styles.up_img} src="./images/new/up.png" alt="up" />
      <img className={styles.belka_img} src="./images/new/belka.png" alt="belka" />
      <img className={styles.chast_img} src="./images/new/chast.png" alt="chast" />
      <img className={styles.vrata_img} src="./images/new/vrata.png" alt="vrata" />
      <img className={styles.cloud_img} src="./images/new/cloud.png" alt="cloud" />

      <img className={styles.lest_mob} src="./images/new/lest.png" alt="lest mobile" />
      <img className={styles.vrata_mob} src="./images/new/vrata_mob.png" alt="vrata mobile" />
      <img className={styles.priz_mob} src="./images/new/priz_mob.png" alt="priz mobile" />
      <img className={styles.psin_mob} src="./images/new/psin_mob.png" alt="psin mobile" />
      <img className={styles.obl_mob} src="./images/new/obl_mob.png" alt="obl mobile" />
      <img className={styles.obl_2_mob} src="./images/new/obl_2_mob.png" alt="obl 2 mobile" />
      <img className={styles.gor} src="./images/new/gor.png" alt="gor" />
      <img className={styles.belka_mob} src="./images/new/belka_mob.png" alt="belka mobile" />
      
      <div className={styles.block_cloud}>
        <img className={styles.line} src="./images/new/download.svg" alt="download" />
        <img className={styles.line_2} src="./images/new/download.svg" alt="download" />
        <img className={styles.line_3} src="./images/new/download.svg" alt="download" />
        <img className={styles.line_4} src="./images/new/download.svg" alt="download" />
      </div>

      <img className={styles.mobile_mob} src="./images/new/mobile.png" alt="mobile" />

      <div className={styles.test_to_copy} onClick={handleCopyToClipboard}>
      A3jryHBxorZ75vLwSr7mMNLfLvmTGxc6UcjyLbMUpump
      </div>
      
      <div className={styles.new_cont}>
        <img className={styles.bgraund} src="./images/new/Group 14.png" alt="background" />
        <div className={styles.content_new}>
          <img className={styles.psina_3} src="./images/new/psi_1.png" alt="psina 1" />
          <div className={styles.p_content}>
            $PEPNUT is 50% Pepe, 50% Peanut and 100% here to make memecoin history. This nutty bastard is throwing open the gates to meme heaven and dragging all degens along for the ride!!! No more waiting on sidelines, no more "I'll catch the next one". Time to catch those salty ball of fun!!! Let's take deez nutz and make history!
          </div>
          <img className={styles.psina_5} src="./images/new/psi_2.png" alt="psina 2" />
        </div>

        <div className={styles.footer}>
          <div className={styles.footer_content}>
            <div className={styles.header_cont2}>
              <div className={styles.left_cont_header}>
                <a
                  className={styles.ref_ico}
                  href="https://t.me/PepenutSolana"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    backgroundImage: "url(images/main/tg_ico.svg)",
                  }}
                ></a>
                <a
                  className={styles.ref_ico}
                  href="https://solscan.io/token/A3jryHBxorZ75vLwSr7mMNLfLvmTGxc6UcjyLbMUpump"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    backgroundImage: "url(images/main/eg_ico.svg)",
                  }}
                ></a>
                <a
                  className={styles.ref_ico}
                  href="https://x.com/pepenutsolana"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    backgroundImage: "url(images/main/x_ico.svg)",
                  }}
                ></a>
                <a
                  className={styles.ref_ico}
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    backgroundImage: "url(images/main/smth_ico.svg)",
                  }}
                ></a>
              </div>
              <div className={styles.right_cont_header}>
                <a
                  className={styles.buy_btn}
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    backgroundImage: "url(images/main/bue_ico.png)",
                  }}
                ></a>
                <a
                  className={styles.ref_ico}
                  href="https://instagram.com/yourusername"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    backgroundImage: "url(images/main/inst_ico.svg)",
                  }}
                ></a>
                <a
                  className={styles.ref_ico}
                  href="https://tiktok.com/@yourusername"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    backgroundImage: "url(images/main/tt_ico.svg)",
                  }}
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
